import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatStepperModule } from '@angular/material';
import { ProgressBarModule } from 'primeng/progressbar';
import { AnalyseComponent } from './components/analyse/analyse.component';
import { ErrorComponent } from './components/error/error.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { PolicyRespComponent } from './components/policy/policy-resp.component';
import { UploaderComponent } from './components/uploader/uploader.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { ApiInfoService } from './services/api-info.service';
import { DownloaderService } from './services/downloader.service';
import { StepperDirective } from './directives/stepper-directive.directive';
import { MatIconModule } from '@angular/material/icon';
import { StepperService } from './services/stepper.service';
import { ModalComponent } from './components/modal/modal.component';
import { LogService } from './services/log.service';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { LocalAnalyseComponent } from './components/localanalyse/local-analyse.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UniversalDeviceDetectorService } from './services/universal-device-detector.service';
import { CommonService } from './services/common.service';

@NgModule({
  declarations: [
    DragAndDropDirective,
    UploaderComponent,
    AnalyseComponent,
    LocalAnalyseComponent,
    ErrorComponent,
    PolicyRespComponent,
    StepperComponent,
    StepperDirective,
    ModalComponent,
  ],
  imports: [
    CommonModule,
    ProgressBarModule,
    MatIconModule,
    MatStepperModule,
    HttpClientModule,
    TranslateModule
  ],
  exports: [
    DragAndDropDirective,
    UploaderComponent,
    AnalyseComponent,
    ErrorComponent,
    StepperComponent,
    PolicyRespComponent,
    ModalComponent,
    HttpClientModule,
    TranslateModule,
    LocalAnalyseComponent
  ],
  providers: [
    ApiInfoService,
    DownloaderService,
    StepperService,
    LogService,
    CommonService,
    {
      provide: DeviceDetectorService,
      useClass: UniversalDeviceDetectorService
    },
  ]
})
export class SharedModule {
}
